import DBStore from "@/core/db_store";
import { getModel } from "@/tables";

// Класс-контроллер для работы со списками (таблицами)
export default class ListController {
	// Store для работы с таблицей
	public store: DBStore;
	// Конфиг для таблицы
	public config: any;
	
	constructor(public name: any, public params: any = {}) {
		// Получить конфиг для таблицы (объединяет дефолтный и переданный)
		this.settings();

		// Создать экземпляр DBStore с полученным конфигом
		this.store = new DBStore(name, this.config);
		
	}

	// Получить конфиг для таблицы (объединяет дефолтный и переданный)
	settings() {
		// Получить модель таблицы
		const model: any = getModel(this.name);

		// Объединить дефолтный конфиг таблицы с переданными параметрами
		this.config = Object.assign(
			model?.forms?.list?.config ? model.forms.list.config : {},
			this.params
		)

		return this.config;
	}

	// Получить данные для setup() компонента
	setup() {
		return {
			store: this.store,
			config: this.config
		}
	}
}